import styles from "../ProductStatusBox.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { ProductType } from "../../../types/types";

export type ProductStatusProps = {
  title: string;
  price: string;
  statusMessage: string;
  handleDescriptionCTA: () => void;
  productType?: ProductType;
  showHowToGetIt: boolean;
  hideTitle?: boolean;
};

export const ProductStatus = ({
  productType,
  statusMessage,
  price,
  title,
  handleDescriptionCTA,
  showHowToGetIt,
  hideTitle = false,
}: ProductStatusProps) => {
  return (
    <div className={styles.info}>
      <h1
        className={hideTitle ? styles.statusMessageSmall : styles.statusMessage}
      >
        {statusMessage}
      </h1>
      {!hideTitle && <p className={styles.title}>{title}</p>}
      {price && <p className={styles.price}>{price}</p>}

      {productType !== "RetiredStaticBundle" ? (
        <UnderlinedButton
          className={hideTitle ? styles.statusLinkNoMargin : styles.statusLink}
          data-testid="skiplinks:top-box-description"
          onClick={handleDescriptionCTA}
        >
          {showHowToGetIt ? "See how to get it" : "View product description"}
        </UnderlinedButton>
      ) : (
        <UnderlinedButton
          tag="a"
          className={hideTitle ? styles.statusLinkNoMargin : styles.statusLink}
          data-testid="skiplinks:top-box-howToReturn"
          href="/customer-services/returns/how-do-i-return-an-item"
        >
          How to return an item
        </UnderlinedButton>
      )}
    </div>
  );
};
